var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgIconLanguage = function SvgIconLanguage(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#FFE9A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M11 20.167a9.167 9.167 0 1 0 0-18.334 9.167 9.167 0 0 0 0 18.334M1.833 11h18.334"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M11 1.833A14.03 14.03 0 0 1 14.667 11 14.03 14.03 0 0 1 11 20.167 14.03 14.03 0 0 1 7.333 11 14.03 14.03 0 0 1 11 1.833"
  }))));
};
export default SvgIconLanguage;